import { render } from "./Information.vue?vue&type=template&id=c10e39c8&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=c10e39c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c10e39c8"

export default script